import { Engine } from '../../core/Engine';
import { UnselectElementCommand } from '../Commands';

export class UnselectElementCommandHandler {
    engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: UnselectElementCommand) {
        this.engine.unselectElement();
    }
}
